export default __webpack_public_path__ + "static/media/partner5.6ea7157f.png";